import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { company } from "../mock";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/products", label: "Products" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-white transition-shadow ${
        scrolled ? "shadow-md" : "border-b border-gray-100"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 md:px-8">
        <Link to="/" className="flex items-center">
          <img src={company.logo} alt={company.name} className="h-12 w-auto md:h-14" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `nav-link font-head text-sm font-600 uppercase tracking-wide ${
                  isActive ? "active text-[#0f2a5a]" : "text-gray-700 hover:text-[#0f2a5a]"
                }`
              }
              style={{ fontWeight: 600 }}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={`tel:${company.phonePrimary.replace(/\s/g, "")}`}
            className="btn-primary flex items-center gap-2 rounded-md px-5 py-2.5 text-sm font-semibold"
          >
            <Phone size={16} />
            {company.phonePrimary}
          </a>
        </div>

        <button
          className="lg:hidden text-[#0f2a5a]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-gray-100 bg-white lg:hidden">
          <nav className="flex flex-col px-5 py-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `border-b border-gray-50 py-3 font-head text-sm font-semibold uppercase tracking-wide ${
                    isActive ? "text-[#1d4ed8]" : "text-gray-800"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={`tel:${company.phonePrimary.replace(/\s/g, "")}`}
              className="btn-primary mt-4 flex items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold"
            >
              <Phone size={16} /> {company.phonePrimary}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
